import React from 'react';

import {
  CuiDescriptionLayout,
  CuiPage,
  CuiPageTitle,
  CuiTextBlock,
} from '../../components';

import { NewsletterSignUpForm } from '../../partials';
// import { BuyCallToAction } from '../../partials';

export const ThanksPage = () => (
  <CuiPage>
    <CuiPageTitle>Thanks!</CuiPageTitle>

    <CuiDescriptionLayout>
      <CuiTextBlock>
        <p>
          Thanks for checking out some ways to use flexbox to build UI
          components! If you&rsquo;d like to know when I add more stuff to this
          site or launch other sites like this, please sign up for the
          newsletter below.
        </p>

        <p>
          <a
            href="http://www.cenizal.com"
            _target="blank"
            rel="noopener noreferrer"
          >
            - CJ Cenizal
          </a>
        </p>
      </CuiTextBlock>
    </CuiDescriptionLayout>

    <NewsletterSignUpForm />
    {/* <BuyCallToAction /> */}
  </CuiPage>
);



// WEBPACK FOOTER //
// ./ui/views/thanks/ThanksPage.js